module.exports = __webpack_public_path__ + "img/interactive-fountain_8.ae287188.jpg";